export default {
  页面曝光: {
    f_module: '页面曝光',
    f_resource: '云首发',
    f_type: 0
  },
  头图: {
    头图: {
      f_module: '头图',
      f_resource: '头图',
      f_type: 1
    },
    头像: {
      f_module: '头图',
      f_resource: '头像',
      f_type: 4
    },
    规则: {
      f_module: '头图',
      f_resource: '规则',
      f_type: 4
    },
    上一个: {
      f_module: '头图',
      f_resource: '上一个',
      f_type: 4
    },
    下一个: {
      f_module: '头图',
      f_resource: '下一个',
      f_type: 4
    },
    视频曝光: function _(txt) {
      return {
        f_module: '头图',
        f_resource: "\u89C6\u9891".concat(txt, "\u66DD\u5149"),
        f_type: 4
      };
    },
    视频播放: function _(txt) {
      return {
        f_module: '头图',
        f_resource: "\u89C6\u9891".concat(txt, "\u64AD\u653E"),
        f_type: 4
      };
    }
  },
  购票信息: {
    购票信息: {
      f_module: '购票信息',
      f_resource: '购票信息',
      f_type: 1
    },
    购票: function _(txt) {
      return {
        f_module: '购票信息',
        f_resource: "\u8D2D\u7968".concat(txt),
        f_type: 4
      };
    },
    演出: function _(txt) {
      return {
        f_module: '购票信息',
        f_resource: "\u6F14\u51FA".concat(txt),
        f_type: 4
      };
    },
    歌单: function _(txt) {
      return {
        f_module: '购票信息',
        f_resource: "\u6B4C\u5355".concat(txt),
        f_type: 4
      };
    },
    晒票根: function _(txt) {
      return {
        f_module: '购票信息',
        f_resource: "\u6652\u7968\u6839".concat(txt),
        f_type: 4
      };
    }
  },
  回顶部: {
    回顶部: {
      f_module: '回顶部',
      f_resource: '回顶部',
      f_type: 1
    },
    回顶部btn: {
      f_module: '回顶部',
      f_resource: '回顶部btn',
      f_type: 4
    }
  },
  送好友: {
    送好友: {
      f_module: '送好友',
      f_resource: '送好友',
      f_type: 1
    },
    赠送好友: {
      f_module: '送好友',
      f_resource: '赠送好友',
      f_type: 4
    },
    查看领取详情: {
      f_module: '送好友',
      f_resource: '查看领取详情',
      f_type: 4
    }
  },
  歌单详情: {
    歌单详情: function _(txt) {
      return {
        f_module: '歌单详情',
        f_resource: "\u6B4C\u5355\u8BE6\u60C5".concat(txt),
        f_type: 1
      };
    },
    购票btn: function btn(txt) {
      return {
        f_module: '歌单详情',
        f_resource: "".concat(txt, "\u8D2D\u7968btn"),
        f_type: 4
      };
    }
  },
  礼包模块: {
    礼包模块: {
      f_module: '礼包模块',
      f_resource: '礼包模块',
      f_type: 1
    },
    礼包规则: {
      f_module: '礼包模块',
      f_resource: '礼包规则',
      f_type: 4
    },
    礼包资产: {
      f_module: '礼包模块',
      f_resource: '礼包资产',
      f_type: 4
    },
    礼包详情: function _(txt) {
      return {
        f_module: '礼包模块',
        f_resource: "".concat(txt, "\u793C\u5305\u8BE6\u60C5"),
        f_type: 4
      };
    }
  },
  抽奖模块: {
    抽奖模块: {
      f_module: '抽奖模块',
      f_resource: '抽奖模块',
      f_type: 1
    },
    抽奖: {
      f_module: '抽奖模块',
      f_resource: '抽奖',
      f_type: 4
    },
    去购票: {
      f_module: '抽奖模块',
      f_resource: '去购票',
      f_type: 4
    },
    去资产: {
      f_module: '抽奖模块',
      f_resource: '去资产',
      f_type: 4
    }
  },
  道具玩法: {
    道具玩法: {
      f_module: '道具玩法',
      f_resource: '道具玩法',
      f_type: 1
    },
    购票: {
      f_module: '道具玩法',
      f_resource: '购票',
      f_type: 4
    },
    发电: {
      f_module: '道具玩法',
      f_resource: '发电',
      f_type: 4
    },
    查看资产: {
      f_module: '道具玩法',
      f_resource: '查看资产',
      f_type: 4
    }
  },
  免费活动: {
    免费活动: {
      f_module: '免费活动',
      f_resource: '免费活动',
      f_type: 1
    },
    活动详情: {
      f_module: '免费活动',
      f_resource: '活动详情',
      f_type: 4
    }
  },
  云首发介绍: {
    云首发介绍: {
      f_module: '云首发介绍',
      f_resource: '云首发介绍',
      f_type: 1
    },
    更多精彩: function _(name) {
      return {
        f_module: '云首发介绍',
        f_resource: "\u66F4\u591A\u7CBE\u5F69".concat(name),
        f_type: 4
      };
    }
  },
  开通弹框: {
    开通弹框: {
      f_module: '开通弹框',
      f_resource: '开通弹框',
      f_type: 1
    },
    原价购买: {
      f_module: '开通弹框',
      f_resource: '原价购买',
      f_type: 4
    },
    开通会员: {
      f_module: '开通弹框',
      f_resource: '开通会员',
      f_type: 4
    }
  },
  支付面板: {
    支付面板: {
      f_module: '支付面板',
      f_resource: '支付面板',
      f_type: 1
    },
    为自己购买: {
      f_module: '支付面板',
      f_resource: '为自己购买',
      f_type: 4
    },
    赠送好友: {
      f_module: '支付面板',
      f_resource: '赠送好友',
      f_type: 4
    },
    开通会员: {
      f_module: '支付面板',
      f_resource: '开通会员',
      f_type: 4
    },
    增加: {
      f_module: '支付面板',
      f_resource: '增加',
      f_type: 4
    },
    减少: {
      f_module: '支付面板',
      f_resource: '减少',
      f_type: 4
    },
    输入份数: {
      f_module: '支付面板',
      f_resource: '输入份数',
      f_type: 4
    },
    立即支付: {
      f_module: '支付面板',
      f_resource: '立即支付',
      f_type: 4
    },
    关闭: {
      f_module: '支付面板',
      f_resource: '关闭',
      f_type: 4
    }
  },
  分享模块: {
    分享模块: function _(txt) {
      return {
        f_module: "\u5206\u4EAB\u6A21\u5757".concat(txt),
        f_resource: '分享模块',
        f_type: 1
      };
    },
    换图: function _(txt) {
      return {
        f_module: "\u5206\u4EAB\u6A21\u5757".concat(txt),
        f_resource: '换图',
        f_type: 4
      };
    },
    关闭: function _(txt) {
      return {
        f_module: "\u5206\u4EAB\u6A21\u5757".concat(txt),
        f_resource: '关闭',
        f_type: 4
      };
    },
    分享渠道: function _(txt) {
      return {
        f_module: "\u5206\u4EAB\u6A21\u5757".concat(txt),
        f_resource: '分享渠道',
        f_type: 4
      };
    },
    分享图: function _(txt) {
      return {
        f_module: "\u5206\u4EAB\u6A21\u5757".concat(txt),
        f_resource: '分享图',
        f_type: 4
      };
    }
  }
};